import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { styled } from "@mui/material/styles";
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
// import createHistory from 'history/createBrowserHistory';

import '../css/AllDevices.css';
import '../css/AddChannel.css';


//component add channel to ai page.
const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 4,
    width: '60vw',
  },
});


class AddChannel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      modalIsOpenEdit: false,
      ChannelName: 'Channel Name',
      ChannelNumber: 'Channel Number',
      channelList: [],
      channelNumberList: [],
      channelNameList: [],
      channelNameSelected: '',
      channelNumberSelected: '',
      ChannelNumber: 'Channel Number',
      editButtonDisable: true,
      nameSelected: false,
      numberSelected: false,
      reRenderComponentChannelName: false,
      reRenderComponentChannelNumber: false
    };
  }


  componentDidMount() {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }

    fetch('/cloud/dropdowndata/', {
      method: "GET",
      headers: headers
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href = '/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {     
        let channelNumberList = data.map((e) => {
          let newVar = {
            "label": e.channel_Number
          }
          return newVar
        })
        let channelNameList = data.map((e) => {
          let newVar = {
            "label": e.channel_name
          }
          return newVar
        })
        this.setState({
          channelList: data,
          channelNumberList,
          channelNameList,
        })
      })
      .catch((err)=>{
console.log(err)
      })
  }



  onReset = () => {
    this.setState({
      channelNumberSelected: '',
      channelNameSelected: '',
      editButtonDisable: true,
      // channelNumberList: [],
      // channelNameList: [],
      reRenderComponent: true
    })

  }

  createLink = () => {
    var createLink = '';
    if (this.state.channelNameSelected !== '') {
      createLink = `1${this.state.channelNameSelected}`
      return createLink
    } else if (this.state.channelNumberSelected !== '') {
      createLink = `0${this.state.channelNumberSelected}`
      return createLink
    } else {
      return null
    }
  }

  onSelectChange = (operationMode, valueSelect) => {
    if (operationMode === 'channelNumber') {
      this.setState({
        channelNumberSelected: valueSelect.value,
        channelNameSelected: '',
      }, () => {
        this.setState({
          reRenderComponentChannelNumber: false,
          reRenderComponentChannelName: true
        }, () => {
          if (this.state.channelNameSelected !== '' || this.state.channelNumberSelected !== '') {
            this.setState({
              editButtonDisable: false,
            })
          }
        })
      })
    } else if (operationMode === 'channelName') {
      this.setState({
        channelNameSelected: valueSelect.value,
        channelNumberSelected: '',
      }, () => {
        this.setState({
          reRenderComponentChannelName: false,
          reRenderComponentChannelNumber: true
        }, () => {
          if (this.state.channelNameSelected !== '' || this.state.channelNumberSelected !== '') {
            this.setState({
              editButtonDisable: false,
            })
          }
        })
      })
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div style={{ width: '100%', paddingLeft: '90px', paddingTop: '40px', paddingRight: '90px' }} >
              <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }} className="text-uppercase"> Select channel name or number to edit</span>
          </div>
          <div className="col-6 mt-3 pl-1"
            onClick={(e) => {
              this.setState({
                nameSelected: false,
                numberSelected: true
              })
            }}>
            <IntegrationReactSelectNew
              placeholder="Channel Number"
              multipleSelect={false}
              content={this.state.channelNumberList}
              onSelect={this.onSelectChange.bind(this, 'channelNumber')}
              IntegrationReactSelectNewLabel="Channel Number"
              reRenderComponent={this.state.reRenderComponentChannelNumber}
            />
          </div>
          <div className="col-6 mt-3 pl-1"
            onClick={(e) => {
              this.setState({
                nameSelected: true,
                numberSelected: false
              })
            }}
          >
            <IntegrationReactSelectNew
              placeholder="Channel Name"
              multipleSelect={false}
              content={this.state.channelNameList}
              onSelect={this.onSelectChange.bind(this, 'channelName')}
              IntegrationReactSelectNewLabel="Channel Name"
              reRenderComponent={this.state.reRenderComponentChannelName}
            />
          </div>
          <div className="swubmitbutton">
            <div className="btn reset-btn mx-2 px-5" onClick={this.onReset.bind(this)}>Reset </div>
            <Link to='/ai/addnewchannel'>
              <div className="btn add-new-btn mx-2 px-5 " >Add New Channel</div>
            </Link>
            <Link to={{
              pathname: `/ai/editchannel/`,
              search: this.createLink(),
            }}>
              <button className="btn edit-btn px-5 button-disabled" disabled={this.state.editButtonDisable} >Edit</button>
            </Link>
            <Link to={{
              pathname: `/ai/deletechannel/`,
              search: this.createLink(),
            }}>
              <button className="btn edit-btn px-5 ml-2 button-disabled" disabled={this.state.editButtonDisable} >Delete</button>
            </Link>
          </div>
        </div>
      </React.Fragment>
    );
  }
}


AddChannel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default styled(styles)(AddChannel);
